export const chatbot = {
   p1: `Configura il tuo Assistente Virtuale`,
   p2: `Attiva il servizio chatbot per rispondere automaticamente alle domande più frequenti dei tuoi ospiti.`,
   p3: `Configura il tuo Assistente Virtuale. Personalizza le risposte del tuo chatbot per fornire informazioni rapide e precise ai tuoi ospiti. Risolvi automaticamente le loro richieste più frequenti.`,
   p4: `Configura`,
   p5: `Assistente Virtuale attivato con successo`,
   p6: `Assistente Virtuale disattivato`,

   p7: `Configura le risposte del ChatBot`,
   p8: `Alloggio assegnato:`,
   p9: `Personalizza le risposte automatiche del chatbot per rispondere in modo efficiente alle domande più frequenti dei tuoi ospiti.`,

   p10: `Hai modifiche non salvate. Vuoi eliminarle e cambiare domanda?`,

   p11: `Domanda:`,
   p12: `Includi un'immagine nella tua risposta`,
   p13: `Carica immagine`,
   p14: `Elimina immagine`,
   p15: `Salva risposta`,
   p16: `Risposta salvata con successo`,
   p17: `Si è verificato un errore durante il salvataggio della risposta.`,

   p18: `Si è verificato un errore durante l'eliminazione dell'immagine.`,
   p19: `Scrivi la tua risposta...`,

   p20: `Blocco di risposta`,
   p21: `Anteprima`,
   p22: ``,
   p23: ``,
   p24: ``,
   p25: ``,
   p26: ``,
   p27: ``,
   p28: ``,
   p29: ``,
   p30: ``,
}
